<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                auditorForm: () => import('../forms/AuditorForm'),
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Auditor', value: 'auditorId', rules: [v => !!v || 'Auditor is required'], isRequired: true, form: () => import('./AuditorForm'), apiMethod: 'Auditors', claim: 'Auditors' },
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'datetime', text: 'End On', value: 'endOn', rules: [] },
                ],
                apiMethod: 'AuditorMembers',
                formTitle: 'Auditor Member',
            }
        },
    };
</script>
